import React from "react";
import { List } from "../modules/Crops/CropsManagement";

export function CropsListPage() {
  return <List />;
}
